var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"438e2cd1e2bafb8b09950b56e57f4b515784bfa8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app-20-next@plant-for-the-planet"]={id:"438e2cd1e2bafb8b09950b56e57f4b515784bfa8"};
      